import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a6be711a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container p-5" }
const _hoisted_2 = { class: "text-center mb-3 mb-lg-5" }
const _hoisted_3 = { class: "fs-6 fw-bold mb-3 mb-lg-5 lh-lg" }
const _hoisted_4 = { class: "fs-6 mb-3 lh-lg" }
const _hoisted_5 = { class: "fs-6 mb-3 mb-lg-5 lh-lg" }
const _hoisted_6 = { class: "d-flex justify-content-center my-3 my-lg-5" }

import { watchEffect } from 'vue'
import { translate } from '@/languages/i18n'
import Button from '@/components/button/index.vue'
import { useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()

const checkSubmit = localStorage.getItem('checkSubmit')
watchEffect(() => {
  if (!checkSubmit) router.push('/community/users/forgot_email')
})
const transitLogin = () => {
  router.push('/users/login')

  localStorage.removeItem('checkSubmit')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(translate)(`SE45resetEmail`)), 1),
    _createElementVNode("h2", _hoisted_3, _toDisplayString(_unref(translate)('CA62sent')), 1),
    _createElementVNode("h2", _hoisted_4, _toDisplayString(_unref(translate)('SE46description2')), 1),
    _createElementVNode("h2", _hoisted_5, _toDisplayString(_unref(translate)('SE46description3')), 1),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(Button, {
        title: _unref(translate)('login'),
        type: 'secondary',
        onClick: transitLogin
      }, null, 8, ["title"])
    ])
  ]))
}
}

})